export enum ChamberReportFields {
  date = "Date",
  cow = "Cow",
  notes = "Notes",
  treatment = "Treatment",
  animalWeightKg = "Animal Weight (Kg)",
  genetics = "Genetics",
  waterL = "Water (L)",
  drinkingMin = "Drinking (Min)",
  rateLMin = "Rate (L/Min)",
  ch4GMadeDrinking = "CH4 (G) made drinking",
  c02GMadeDrinking = "C02 (G) made drinking",
  feedKgStart = "Feed (Kg) - Start",
  feedKgEnd = "Feed (Kg) - End",
  eatingMin = "Eating (Min)",
  bouts = "Bouts",
  rateKgMin = "Rate (Kg/Min)",
  ch4GMadeEating = "CH4 (G) made eating",
  c02GMadeEating = "C02 (G) made eating",
  standingRestingMin = "Standing / Resting (Min)",
  ch4GMadeStanding = "CH4 (G) made standing",
  c02GMadeStanding = "C02 (G) made standing",
  ch4G = "CH4 (G)",
  c02G = "C02 (G)",
  ch4GEffKgOfBodyWeight = "CH4 (G) Eff/Kg of Body Weight",
  c02GEffKgOfBodyWeight = "C02 (G) Eff/kg of Body Weight",
  ambientChamberTempC = "Ambient Chamber Temp C",
  finalTempC = "Final Temp C",
  cowInducedTempChangeC = "Cow induced temp change C",
  ambient02Perc = "Ambient 02 %",
  final02Perc = "Final 02%",
  o2PercEff = "02 % Eff",
  averageTemp = "Average Temp",
  averageHumidity = "Average Humdiity",
}

export const fieldGroupFirstFieldToGroupName = {
  [ChamberReportFields.date]: "Information",
  [ChamberReportFields.waterL]: "Drinking",
  [ChamberReportFields.feedKgStart]: "Eating",
  [ChamberReportFields.standingRestingMin]: "Resting",
  [ChamberReportFields.ch4G]: "Gas Total",
  [ChamberReportFields.ch4GEffKgOfBodyWeight]: "Gas / Weight",
  [ChamberReportFields.ambientChamberTempC]: "Temperature",
  [ChamberReportFields.ambient02Perc]: "O2",
  [ChamberReportFields.averageTemp]: "Average Temperature, Humidity",
};

export const goodRangesForChamberReport: {
  [key: string]: { min: number; max: number };
} = {
  drinkingPerDay: {
    min: 17.5,
    max: 50,
  },
  eatingMinsPerDay: {
    min: 60,
    max: 105,
  },
  restingMinsPerDay: {
    min: 180,
    max: 210,
  },
  Co2gPerDay: {
    min: 2300,
    max: 3400,
  },
  Ch4gPerDay: {
    min: 62.5,
    max: 125,
  },
  weight: {
    min: 350,
    max: 770,
  },
};

export const sliderRanges: { [key: string]: { min: number; max: number } } = {
  [ChamberReportFields.waterL]: {
    min: 0,
    max: 30,
  },
  [ChamberReportFields.eatingMin]: {
    min: 0,
    max: 250,
  },
  [ChamberReportFields.standingRestingMin]: {
    min: 0,
    max: 250,
  },
  [ChamberReportFields.ch4G]: {
    min: 0,
    max: 150,
  },
  [ChamberReportFields.c02G]: {
    min: 0,
    max: 4000,
  },
  [ChamberReportFields.bouts]: {
    min: 0,
    max: 20,
  },
};

export interface IChamberTrial {
  date: string;
  chamberName: string;
  fields: { [key in keyof typeof ChamberReportFields]?: string | number };
}
